import { initialState } from '../state/initialStates';
import { generalReducer } from './generalReducer';
import { formReducer } from './formReducer';
import { authReducer } from './authReducer';
import { registrationReducer } from './registrationReducer';
import { paymentReducer } from './paymentReducer';

const reducer = (state = initialState, action) => {
  return {
    generalStates: generalReducer(state.generalStates, action),
    formStates: formReducer(state.formStates, action),
    authStates: authReducer(state.authStates, action),
    registrationStates: registrationReducer(state.registrationStates, action),
    paymentStates: paymentReducer(state.paymentStates, action)
  }
};

export { initialState, reducer };